module.exports = __webpack_public_path__ + "static/b2-d42540e79322201303ecf33677b838bd.png";